export default {
  // Menus
  'menu.recommendations': '好站推荐链接',
  'menu.gallery-detail-ads': '图库页广告',
  'site-setting': '站点配置',
  'site-setting.basic': '基本配置',
  'site-setting.recommendations': '好站推荐链接',
  'site-setting.gallery-detail-ads': '图库页广告',
  'frontend-users': '图库用户管理',
  'user-posts': '用户帖子管理',
  'user-comments': '用户评论管理',
  'admin-users': '后台用户管理',

  // Site settings
  'site.loadError': '加载站点配置失败',
  'site.saveSuccess': '保存成功',
  'site.saveError': '保存失败',
  'site.title.label': '站点标题',
  'site.title.required': '请输入站点标题',
  'site.announcement.label': '公告',
  'site.customerServiceLink.label': '客服链接',
  'site.customerServiceLink.required': '请输入客服链接',
  'site.appIcon.label': '下载图标',
  'site.bannerPics.label': '横幅广告轮播图',
  'site.bannerPics.delete': '删除',
  'site.bannerPics.image': '图片',
  'site.bannerPics.image.required': '请上传横幅广告轮播图链接',
  'site.bannerPics.url': '跳转链接',

  // Recommendations
  'recommendations.tab.website': '网站推荐',
  'recommendations.tab.guarantee': '担保推荐',
  'recommendations.loadError': '加载推荐数据失败',
  'recommendations.saveSuccess': '保存成功',
  'recommendations.saveError': '保存失败',
  'recommendations.action.add': '新增推荐',
  'recommendations.action.saveList': '保存推荐列表',
  'recommendations.list.label': '域名链接',
  'recommendations.form.name': '域名',
  'recommendations.form.name.required': '请输入域名',
  'recommendations.form.url': '链接地址',
  'recommendations.form.url.required': '请输入链接地址',
  'recommendations.form.imageUrl': '图片地址',
  'recommendations.form.imageUrl.required': '请输入图片地址',

  // Gallery detail ads
  'galleryAds.loadError': '加载画廊广告失败',
  'galleryAds.saveSuccess': '保存成功',
  'galleryAds.saveError': '保存失败',
  'galleryAds.brandName': '品牌名称',
  'galleryAds.brandName.required': '请输入品牌名称',
  'galleryAds.ctaUrl': '落地页链接',
  'galleryAds.ctaUrl.required': '请输入落地页链接',
  'galleryAds.bbsName': '论坛名称',
  'galleryAds.bbsName.required': '请输入论坛名称',
  'galleryAds.bbsUrl': '论坛链接',
  'galleryAds.bbsUrl.required': '请输入论坛链接',
  'galleryAds.bannerPics': '横幅广告轮播图',
  'galleryAds.bannerPics.delete': '删除',
  'galleryAds.bannerPics.duplicate': '复制',
  'galleryAds.bannerPics.image': '图片',
  'galleryAds.bannerPics.image.required': '请上传图片链接',
  'galleryAds.bannerPics.url': '跳转链接',
  'galleryAds.sites': '站点信息',
  'galleryAds.sites.delete': '删除',
  'galleryAds.sites.duplicate': '复制',
  'galleryAds.sites.name': '站点名称',
  'galleryAds.sites.name.required': '请输入站点名称',
  'galleryAds.sites.url': '站点链接',
  'galleryAds.sites.url.required': '请输入站点链接',

  // Users
  'users.delete.success': '用户删除成功',
  'users.delete.error': '用户删除失败',
  'users.delete.admin.readonly': 'admin 账号不可删除',
  'users.reset.success': '密码重置成功',
  'users.reset.error': '密码重置失败',
  'users.create.success': '用户创建成功',
  'users.create.error': '用户创建失败',
  'users.privileges.save.success': '权限更新成功',
  'users.privileges.save.error': '权限更新失败',
  'users.privileges.admin.readonly': 'admin 账号的权限不可修改',
  'users.columns.username': '用户名',
  'users.columns.twoFactorEnabled': '两步验证',
  'users.2fa.action.generateQR': '生成二维码',
  'users.2fa.action.unbind': '解绑',
  'users.2fa.modal.title': '绑定两步验证',
  'users.2fa.unbind.confirmTitle': '确认解绑两步验证',
  'users.2fa.unbind.confirmContent': '确认为用户 {name} 解绑两步验证吗？',
  'users.2fa.unbind.success': '两步验证解绑成功',
  'users.2fa.unbind.error': '两步验证解绑失败',
  'users.columns.editSiteSetting': '站点配置',
  'users.columns.manageRecommendation': '好站推荐链接',
  'users.columns.editGalleryDetailAds': '图库页广告',
  'users.columns.manageFrontendUsers': '前台用户管理',
  'users.columns.manageUserPosts': '用户帖子管理',
  'users.columns.manageUserComments': '用户评论管理',
  'users.columns.actions': '操作',
  'users.actions.resetPassword': '重置密码',
  'users.actions.delete': '删除',
  'users.confirm.deleteTitle': '确认删除用户',
  'users.confirm.deleteContent': '确定要删除用户 {name} 吗？',
  'users.confirm.deleteNote': '此操作不可撤销。',
  'users.modal.resetTitle': '重置用户密码',
  'users.modal.resetForUser': '为用户 {name} 设置新密码：',
  'users.modal.createTitle': '创建新用户',
  'users.modal.editPrivilegesTitle': '编辑 {name} 的权限',
  'users.privileges.title': '权限设置',
  'users.actions.savePrivileges': '保存权限',
  'users.actions.cancel': '取消',
  'users.form.username': '用户名',
  'users.form.username.placeholder': '请输入用户名',
  'users.form.username.required': '请输入用户名',
  'users.form.password': '密码',
  'users.form.password.placeholder': '请输入密码',
  'users.form.password.required': '请输入密码',
  'users.form.password.min': '密码至少6位',
  'users.form.newPassword': '新密码',
  'users.form.newPassword.placeholder': '请输入新密码',
  'users.form.newPassword.required': '请输入新密码',
  'users.form.newPassword.min': '密码至少6位',
  'users.form.confirmPassword': '确认密码',
  'users.form.confirmPassword.placeholder': '请确认新密码',
  'users.form.confirmPassword.required': '请确认新密码',
  'users.privilege.editSiteSetting': '站点配置',
  'users.privilege.manageRecommendation': '好站推荐链接',
  'users.privilege.editGalleryDetailAds': '图库页广告',
  'users.privilege.manageFrontendUsers': '前台用户管理',
  'users.privilege.manageUserPosts': '用户帖子管理',
  'users.privilege.manageUserComments': '用户评论管理',

  // Frontend Users
  'feUsers.status.normal': '正常',
  'feUsers.status.blocked': '封禁',
  'feUsers.permission.enabled': '允许',
  'feUsers.permission.disabled': '禁止',
  'feUsers.search.userId': '用户ID',
  'feUsers.columns.id': 'ID',
  'feUsers.columns.username': '用户名',
  'feUsers.columns.nickname': '昵称',
  'feUsers.columns.avatar': '头像地址',
  'feUsers.columns.email': '邮箱',
  'feUsers.columns.mobile': '手机号',
  'feUsers.columns.accountStatus': '账号状态',
  'feUsers.columns.postingPermission': '发帖权限',
  'feUsers.columns.commentingPermission': '评论权限',
  'feUsers.columns.invitationCode': '邀请码',
  'feUsers.columns.lastLoginIpAddress': '最近登录 IP',
  'feUsers.columns.lastLoginAt': '最近登录时间',
  'feUsers.columns.registrationTime': '注册时间',
  'feUsers.columns.actions': '操作',
  'feUsers.actions.create': '新建',
  'feUsers.actions.edit': '编辑',
  'feUsers.actions.more': '更多',
  'feUsers.actions.setNormal': '设为正常',
  'feUsers.actions.setBlocked': '设为封禁',
  'feUsers.actions.block': '封禁账号',
  'feUsers.actions.enablePosting': '允许发帖',
  'feUsers.actions.disablePosting': '禁止发帖',
  'feUsers.actions.enableCommenting': '允许评论',
  'feUsers.actions.disableCommenting': '禁止评论',
  'feUsers.actions.resetPassword': '重置密码',
  'feUsers.actions.viewPosts': '查看帖子',
  'feUsers.actions.delete': '删除',
  'feUsers.actions.save': '保存',
  'feUsers.actions.batchNormal': '批量设为正常',
  'feUsers.actions.batchBlocked': '批量设为封禁',
  'feUsers.actions.batchEnablePosting': '批量允许发帖',
  'feUsers.actions.batchDisablePosting': '批量禁止发帖',
  'feUsers.actions.batchEnableCommenting': '批量允许评论',
  'feUsers.actions.batchDisableCommenting': '批量禁止评论',
  'feUsers.drawer.createTitle': '创建前台用户',
  'feUsers.drawer.editTitle': '编辑前台用户',
  'feUsers.form.password': '密码',
  'feUsers.form.password.required': '请输入密码',
  'feUsers.form.nickname': '昵称',
  'feUsers.form.avatar': '头像地址',
  'feUsers.form.mobile': '手机号',
  'feUsers.form.mobile.required': '请输入手机号',
  'feUsers.form.lastLoginIpAddress': '最近登录 IP',
  'feUsers.form.postingPermission': '允许发帖',
  'feUsers.form.commentingPermission': '允许评论',
  'feUsers.messages.selectRequired': '请先选择用户',
  'feUsers.messages.createSuccess': '前台用户创建成功',
  'feUsers.messages.createError': '前台用户创建失败',
  'feUsers.messages.updateSuccess': '前台用户更新成功',
  'feUsers.messages.updateError': '前台用户更新失败',
  'feUsers.messages.deleteSuccess': '前台用户删除成功',
  'feUsers.messages.deleteError': '前台用户删除失败',
  'feUsers.messages.resetError': '重置密码失败',
  'feUsers.messages.statusSuccess': '账号状态更新成功',
  'feUsers.messages.statusError': '账号状态更新失败',
  'feUsers.messages.blockSuccess': '账号封禁成功',
  'feUsers.messages.blockError': '账号封禁失败',
  'feUsers.messages.permissionSuccess': '权限更新成功',
  'feUsers.messages.permissionError': '权限更新失败',
  'feUsers.messages.batchSuccess': '批量操作成功',
  'feUsers.messages.batchError': '批量操作失败',
  'feUsers.confirm.deleteTitle': '确认删除用户',
  'feUsers.confirm.deleteContent': '确认删除用户 {name} 吗？',
  'feUsers.reset.confirmTitle': '确认重置密码',
  'feUsers.reset.confirmContent': '确认重置用户 {name} 的密码吗？',
  'feUsers.reset.title': '重置密码结果',
  'feUsers.reset.description': '临时密码如下，请及时复制：',

  // Change password
  'password.mismatch': '两次输入的密码不一致',
  'password.change.success': '密码修改成功',
  'password.change.error': '密码修改失败',
  'password.form.submit': '修改密码',
  'password.form.new': '新密码',
  'password.form.new.placeholder': '请输入新密码',
  'password.form.new.required': '请输入新密码',
  'password.form.new.min': '密码至少6位',
  'password.form.confirm': '确认密码',
  'password.form.confirm.placeholder': '请再次输入新密码',
  'password.form.confirm.required': '请确认新密码',
  'password.form.confirm.min': '密码至少6位',

  // 2FA setup
  '2fa.error.generic': '错误',
  '2fa.warning.enterCode': '请输入验证码',
  '2fa.success.enable': '验证器开启成功',
  '2fa.error.invalid': '验证码错误',
  '2fa.page.title': '验证器设置',
  '2fa.bound': '已绑定验证器',
  '2fa.bind': '绑定验证器',
  '2fa.scan': '扫描二维码',
  '2fa.verify': '验证',
  '2fa.input.placeholder': '输入6位验证码',
  '2fa.button.verify': '验证并绑定',

  // Login
  'login.2fa.title': '二步验证',

  // Welcome page
  'welcome.title': '欢迎使用图库内容管理系统',
  'welcome.desc': '通过以下几个步骤，您可以方便地定义您的站点内容。',
  'welcome.notice.deprecated': '区块/栏目/广告编辑功能已下线，等待 swagger 接口完善后再恢复。',
  'welcome.steps.siteSetting.title': '站点配置',
  'welcome.steps.siteSetting.desc': '配置站点标题、公告、客服链接、下载图标和横幅广告轮播图。',
  'welcome.steps.recommendations.title': '好站推荐链接',
  'welcome.steps.recommendations.desc': '维护网站/担保推荐条目，填写链接和图片。',
  'welcome.steps.galleryAds.title': '图库页广告',
  'welcome.steps.galleryAds.desc': '编辑图库页广告：品牌与落地页、论坛信息、横幅和站点列表。',

  // Blocks
  'blocks.save.success': '保存成功',
  'blocks.save.error': '保存失败',
  'blocks.updatedAt': '更新于: {time} ({relative})',

  // Upload
  'upload.button': '上传',
  'upload.success': '图片上传成功',
  'upload.error': '图片上传失败',

  // Header
  'header.menu.changePassword': '修改密码',
  'header.menu.setup2fa': '绑定验证器',
  'header.menu.logout': '退出登录',
  'userPosts.search.authorId': '作者ID',
  'userPosts.search.authorNickname': '作者昵称',
  'userPosts.columns.id': '帖子ID',
  'userPosts.columns.authorId': '作者ID',
  'userPosts.columns.authorNickname': '作者昵称',
  'userPosts.columns.title': '标题',
  'userPosts.columns.content': '内容',
  'userPosts.columns.imageUrls': '图片',
  'userPosts.columns.isFeatured': '精选',
  'userPosts.columns.approved': '审核状态',
  'userPosts.columns.createdAt': '创建时间',
  'userPosts.columns.updatedAt': '更新时间',
  'userPosts.columns.actions': '操作',
  'userPosts.actions.approve': '通过',
  'userPosts.actions.disapprove': '拒绝',
  'userPosts.actions.batchApprove': '批量通过',
  'userPosts.actions.batchDisapprove': '批量拒绝',
  'userPosts.actions.edit': '编辑',
  'userPosts.actions.delete': '删除',
  'userPosts.actions.save': '保存',
  'userPosts.drawer.editTitle': '编辑帖子',
  'userPosts.form.title': '标题',
  'userPosts.form.content': '内容',
  'userPosts.form.imageUrls': '图片地址',
  'userPosts.form.imageUrls.help': '多个地址用逗号分隔',
  'userPosts.form.isFeatured': '精选',
  'userPosts.isFeatured.yes': '是',
  'userPosts.isFeatured.no': '否',
  'userPosts.approved.yes': '已通过',
  'userPosts.approved.no': '未通过',
  'userPosts.messages.updateSuccess': '帖子更新成功',
  'userPosts.messages.updateError': '帖子更新失败',
  'userPosts.messages.deleteSuccess': '帖子删除成功',
  'userPosts.messages.deleteError': '帖子删除失败',
  'userPosts.messages.approveSuccess': '帖子审核通过',
  'userPosts.messages.approveError': '帖子审核失败',
  'userPosts.messages.disapproveSuccess': '帖子已拒绝',
  'userPosts.messages.disapproveError': '帖子拒绝失败',
  'userPosts.messages.batchApproveSuccess': '批量通过 {count} 条帖子',
  'userPosts.messages.batchApproveError': '批量通过失败',
  'userPosts.messages.batchDisapproveSuccess': '批量拒绝 {count} 条帖子',
  'userPosts.messages.batchDisapproveError': '批量拒绝失败',
  'userPosts.messages.batchSkipped': '跳过 {count} 条帖子',
  'userPosts.confirm.deleteTitle': '确认删除帖子',
  'userPosts.confirm.deleteContent': '确认删除帖子 {id} 吗？',
  'userPosts.confirm.approveTitle': '确认通过帖子',
  'userPosts.confirm.approveContent': '确认通过帖子 {id} 吗？',
  'userPosts.confirm.disapproveTitle': '确认拒绝帖子',
  'userPosts.confirm.disapproveContent': '确认拒绝帖子 {id} 吗？',
  'userPosts.confirm.batchApproveTitle': '确认批量通过',
  'userPosts.confirm.batchApproveContent': '确认通过选中的 {count} 条帖子吗？',
  'userPosts.confirm.batchDisapproveTitle': '确认批量拒绝',
  'userPosts.confirm.batchDisapproveContent': '确认拒绝选中的 {count} 条帖子吗？',

  // User comments
  'userComments.search.authorId': '作者ID',
  'userComments.search.authorNickname': '作者昵称',
  'userComments.search.parentCommentId': '父评论ID',
  'userComments.columns.id': '评论ID',
  'userComments.columns.authorId': '作者ID',
  'userComments.columns.authorNickname': '作者昵称',
  'userComments.columns.postId': '帖子ID',
  'userComments.columns.content': '内容',
  'userComments.columns.approved': '审核状态',
  'userComments.columns.createdAt': '创建时间',
  'userComments.columns.updatedAt': '更新时间',
  'userComments.columns.actions': '操作',
  'userComments.actions.approve': '通过',
  'userComments.actions.disapprove': '拒绝',
  'userComments.actions.batchApprove': '批量通过',
  'userComments.actions.batchDisapprove': '批量拒绝',
  'userComments.actions.edit': '编辑',
  'userComments.actions.delete': '删除',
  'userComments.actions.save': '保存',
  'userComments.drawer.editTitle': '编辑评论',
  'userComments.form.content': '内容',
  'userComments.approved.yes': '已通过',
  'userComments.approved.no': '未通过',
  'userComments.messages.updateSuccess': '评论更新成功',
  'userComments.messages.updateError': '评论更新失败',
  'userComments.messages.deleteSuccess': '评论删除成功',
  'userComments.messages.deleteError': '评论删除失败',
  'userComments.messages.approveSuccess': '评论审核通过',
  'userComments.messages.approveError': '评论审核失败',
  'userComments.messages.disapproveSuccess': '评论已拒绝',
  'userComments.messages.disapproveError': '评论拒绝失败',
  'userComments.messages.batchApproveSuccess': '批量通过 {count} 条评论',
  'userComments.messages.batchApproveError': '批量通过失败',
  'userComments.messages.batchDisapproveSuccess': '批量拒绝 {count} 条评论',
  'userComments.messages.batchDisapproveError': '批量拒绝失败',
  'userComments.messages.batchSkipped': '跳过 {count} 条评论',
  'userComments.confirm.deleteTitle': '确认删除评论',
  'userComments.confirm.deleteContent': '确认删除评论 {id} 吗？',
  'userComments.confirm.approveTitle': '确认通过评论',
  'userComments.confirm.approveContent': '确认通过评论 {id} 吗？',
  'userComments.confirm.disapproveTitle': '确认拒绝评论',
  'userComments.confirm.disapproveContent': '确认拒绝评论 {id} 吗？',
  'userComments.confirm.batchApproveTitle': '确认批量通过',
  'userComments.confirm.batchApproveContent': '确认通过选中的 {count} 条评论吗？',
  'userComments.confirm.batchDisapproveTitle': '确认批量拒绝',
  'userComments.confirm.batchDisapproveContent': '确认拒绝选中的 {count} 条评论吗？',

  // Lottery Draw Records
  'lotteryRecords.search.lotteryType': '彩票类型',
  'lotteryRecords.search.issue': '期号',
  'lotteryRecords.columns.issue': '期号',
  'lotteryRecords.columns.gameDay': '开奖日期',
  'lotteryRecords.columns.openTime': '开奖时间',
  'lotteryRecords.columns.numbers': '开奖号码',
  'lotteryRecords.columns.sum': '总和',
  'lotteryRecords.columns.zodiacs': '生肖',
  'lotteryRecords.columns.colors': '波色',
  'lotteryRecords.columns.elements': '五行',
  'lotteryRecords.columns.bigSmall': '大小',
  'lotteryRecords.columns.oddEven': '单双',
  'lotteryRecords.actions.create': '新增开奖记录',
  'lotteryRecords.modal.createTitle': '新增开奖记录',
  'lotteryRecords.form.lotteryType': '彩票类型',
  'lotteryRecords.form.lotteryType.required': '请选择彩票类型',
  'lotteryRecords.form.issue': '期号序号',
  'lotteryRecords.form.issue.required': '请输入3位期号序号',
  'lotteryRecords.form.issue.placeholder': '例如：036',
  'lotteryRecords.form.numbers': '开奖号码',
  'lotteryRecords.form.numbers.required': '请输入7个开奖号码',
  'lotteryRecords.form.numbers.placeholder': '逗号分隔的7个号码，例如：36,26,37,02,44,31,28',
  'lotteryRecords.form.numbers.invalid': '请输入7个有效号码，每个号码范围为1-49',
  'lotteryRecords.messages.createSuccess': '开奖记录创建成功',
  'lotteryRecords.messages.createError': '创建失败，请重试',
  'lotteryRecords.messages.createConflict': '该期号的开奖记录已存在',
  'lotteryRecords.form.gameDay': '开奖日期',
  'lotteryRecords.form.gameDay.placeholder': '例如：20260307',
  'lotteryRecords.columns.actions': '操作',
  'lotteryRecords.actions.delete': '删除',
  'lotteryRecords.confirm.deleteTitle': '确认删除开奖记录',
  'lotteryRecords.confirm.deleteContent': '确认删除期号 {issue} 的开奖记录吗？此操作不可撤销。',
  'lotteryRecords.messages.deleteSuccess': '开奖记录已删除',
  'lotteryRecords.messages.deleteError': '删除失败，请重试',
};
